import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { TitleHeader } from 'web-library';
import { useHistory } from 'react-router-dom';
import { AUTHORITY_NAMES } from 'web-library/models/AuthorityFunctions';
import RouteKey from '../../routes/key';
import { useGetUserAuthorities } from '../../api-refactored/user/useGetUserAuthorities';
import ListDataArchivalReport from '../../modules/admin/components/DataArchivalReport/ListDataArchivalReport';

const { error } = RouteKey.child;
const { generic } = RouteKey.error.child;

const DataArchivalReport = () => {
  const { t } = useTranslation();
  const history = useHistory();

  const { data: userAuthoritiesData = [], isSuccess: isGetAuthoritiesSuccess } =
    useGetUserAuthorities();

  useEffect(() => {
    if (isGetAuthoritiesSuccess) {
      if (!userAuthoritiesData.includes(AUTHORITY_NAMES.CP_ADMIN_DATA_ARCHIVAL_REPORT_VIEW)) {
        history.push(`/${error}/${generic}`);
      }
    }
  }, [history, userAuthoritiesData, isGetAuthoritiesSuccess]);

  return (
    <>
      <TitleHeader title={t('admin->>DataArchivalReport.DataArchivalReport')} />
      <ListDataArchivalReport />
    </>
  );
};

export default DataArchivalReport;
